import PropTypes from "prop-types";

export const CheckoutPropType = PropTypes.shape({
  id: PropTypes.node,
  name: PropTypes.node,
  total: PropTypes.node,
  installment_count: PropTypes.node,
  payment_types: PropTypes.array,
});
